import React, { useState } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";
import Modal, { ModalProvider, BaseModalBackground } from "styled-react-modal";
import { Theme } from "../styles/Theme";
import CloseIcon from '@mui/icons-material/Close';
import LabelText from "./LabelText";


const StyledModal = Modal.styled(({ theme }: { theme: Theme }) => `
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  border: ${theme.borderColor};
  background: ${theme.dropdownBorderColor};
  width: fit-content;
  height:fit-content;
  padding: 48px;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  flex-shrink: 0;
  transition : all 0.3s ease-in-out;
`);

const ModalHeader = styled.div`
border-bottom : 1px silid ${({ theme }) => theme.playerDataBorder}
`;

const ContentFrame = styled.div`
display: flex;
// width: 412px;
flex-direction: column;
align-items: flex-start;
gap: 48px;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    // gap: 24px;
    align-self: stretch;
    // border-bottom:1px solid  ${({ theme }) => theme.playerDataBorder};

    .modal-header{
      display: flex;
      align-items: flex-start;
      gap: 24px;
      align-self: stretch;
      flex-direction:column;
      border-bottom:1px solid  ${({ theme }) => theme.playerDataBorder}
    }
    .modal-header-title{
      display:flex;
      flex-direction: row;
    }
    .title{
      text-align:left;
      width:598px;
      flex: 1 0 0;
      color: ${({ theme }) => theme.color};

    }
    .sub-title{
      display: flex;
      width: 678px;
      height: 55px;
      padding-bottom: 3px;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      gap: 12px;
      border-bottom:1px solid  ${({ theme }) => theme.playerDataBorder};
    }
`;

const Closebtn = styled.div`
    display: flex;
    width: 48px;
    height: 48px;
    padding: 12px;
    justify-content: center;
    align-items: center;
    cursor:pointer;

    border-radius: 300px;
    border: 1px solid ${({ theme }) => theme.tabBorderColor};

    .cta-btn-icons {
       fill: ${({ theme }) => theme.ctaIconsColor};
    }
`;



const SubContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
`;


const Description = styled.div`
    width: 678px;
    text-align: start;
    color: var(--Warm-Grey-warm-grey-600, #7C7D79);

    .modal-description-text {
        white-space: pre-line;
        font-family: Aeonik;
        font-size: 20px;
    }
  
`;
interface ModalItem {
  subTitle?: string;
  description: string;

}

interface ModalData {
  headerTitle: string;
  actionTag: string;
  items: ModalItem[];
}
interface LargeModalProps {
  toggleLargeModal: () => void;
  isOpen: boolean;
  data: ModalData;
}
const LargeModal: React.FC<LargeModalProps> = ({ toggleLargeModal, isOpen, data }) => {

  return (
    <div>

      <StyledModal
        isOpen={isOpen}
      >
        <ContentFrame>
          <Content>
            <div className="modal-header">
                  <div className="modal-header-title">
                    <div className="title">
                      <LabelText className="page-title-text">{data.headerTitle}</LabelText>
                    </div>
                    <Closebtn onClick={toggleLargeModal}>
                      <CloseIcon sx={{ fontSize: '2rem' }} className='cta-btn-icons' />
                    </Closebtn>
                  </div>
              {/* {data.items[0]?.subTitle !== "" && <LabelText className="drawer-title">{data.items[0].subTitle}</LabelText>} */}
              {/* {data.items.map((item, index) => (
                <LabelText className="drawer-title">{item.subTitle}</LabelText>
              ))} */}
            </div>

            {data.items.map((item, index) => (
              <SubContent key={index}>
                <Description>
                  <div>
                    <LabelText className="drawer-title">{item.subTitle}</LabelText>
                  </div>
                  <div>
                    <LabelText className="modal-description-text">{item.description}</LabelText>
                  </div>
                </Description>
              </SubContent>
            ))}

          </Content>
          {/* <ActionContent>
                    <span className="action-tag">Lorem ipsum dolor sit amet, consectetur</span>
                    <div className="actions-btn">
                        <SecondaryButton label="cancel"/>
                        <PrimaryButton label="Yes, do it"/>
                    </div>
            </ActionContent> */}
        </ContentFrame>
      </StyledModal>
    </div>
  );
}
export default LargeModal;

